<template>
    <div class="modal-backdrop">
        <div class="card borderradius10 col-lg-4 col-md-6 mt-md-4 col-11 p-0">
            <div class="modal-content postmodalcontent borderradius10" >
                <div class="modal-header p-4 borderradius10">
                    <div class="d-lg-flex">
                    </div>   
                    <button type="button" class="close" @click="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body p-4 borderradius10 bodymodal11" v-if="!submittedForm">
                    <div class="d-flex flex-column">
                        <span class="proximanova black fontsize14 required">Message</span>
                        <textarea name="message" class="borderradius10 fontsize14 p-2 mt-1" maxlength="400" placeholder="Start typing your message here..." v-model="message" id="message" cols="30" rows="5"></textarea>
                    </div>
                    <div class="d-flex flex-column mt-2">
                        <span class="proximanova black fontsize14">Link to existing jobs list</span>
                        <div>
                        <div class=" input-group borderblack borderradius10 search-input p-0 mr-2 mt-1"  >
                            <div class="input-group-prepend " >
                                <span class="input-group-text img-input-group" id="basic-text">
                                    <img :src="searchimg" class="imgborder searchedInput" alt="search"/> 
                                </span>
                            </div>
                            <input class="form-control input-border border-0 borderradius10" type="text" 
                                placeholder="Job Title"  id="searchedInput" autocomplete="off"
                                aria-label="Search"  v-model="jobText" @input="fetchJobsList"
                            />
                        </div>
                        <div class="dropdown-menu col-10 d-flex ml-4 shadow" id="LocationDropdown" v-if="searchJobsList.length > 0 || jobText.length>=3"> 
                          <div class="mx-auto" v-if="jobsearchLoader">
                            <img src="../../assets/loading_gif1.gif" class="mx-auto" width="30px" alt="loading">
                          </div>
                          <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer" v-else>
                            <li class="list-group-item pl-3" :value="job.jobId" v-for="(job,i) in searchJobsList" :key="i" @click="selectingJobFroRequest(job)">
                              {{job.jobTitle}}
                            </li>
                          </div>
                        </div>
                        </div>
                        <div v-if="selectedJobForRequest">
                          <span class="borderblack60 text-capitalize pl-2 pr-2 pointer lineheight p-1 mt-2 mr-2 borderradius20 fontsize12 proximanova-semibold">
                            {{selectedJobForRequest.jobTitle}}
                          </span>
                        </div>
                    </div>
                    <div class="mt-5 text-center">
                      <img src="../../assets/uploadvideo.svg" width="32px" alt="uploading" class="img-fluid ml-2 mr-2" v-if="sendRequestBtnClicked">
                      <button v-else :disabled="!selectedJobForRequest || !message" class="black borderadius12 p-2 col-12 fontsize14 text-nowrap mr-2 mt-2 mt-lg-0 mt-md-0" :class="{'backgroundcolorblack white pointer': (selectedJobForRequest && message)}" @click="submitResumeRequest">Send Request for Resume</button>
                    </div>
                </div>
                <div class="modal-body p-4 borderradius10 bodymodal11" v-else>
                    <div class="col-10 d-flex flex-column text-center pb-3 mx-auto">
                        <img src="../../assets/tickmark_black.svg" alt="tick" class="img-fluid mx-auto" height="60px" width="60px">
                        <span class="proximanova-bold black fontsize28 mt-3">Successfully</span>
                        <span class="proximanova black fontsize14 mt-2">Request raised for resume you can check the request under your job listing</span>
                    </div>
                </div>
            </div>
        </div>
    </div>  
</template>

<script>
import httpjob from "@/js/http-postjob.js"
import sessionUtils from "@/js/session-util.js";
export default{
   data() {
    return{
        message : "",
        jobText : "",
        searchimg: require('../../assets/Designation.svg'),
        businessAccountId : null,
        userEmail : null,
        submittedForm : false,
        jobsearchLoader : false,
        searchJobsList : [],
        selectedJobForRequest : null,
        sendRequestBtnClicked : false,
        recruiterProfileId : '',
    }
  },
  props : [
        'userObject'
    ],
  methods:{
    close() {
      this.$emit('closeRequestResumeModal', "cancel" );
    },
    fetchJobsList() {
      console.log("calling API to fetch jobs list based on search text : ", this.jobText)
      if(this.jobText.length >=3 ){
        this.jobsearchLoader = true;
        this.searchJobsList = [];
        httpjob.get('/postjob/getJobListBySearchText?businessAccountId='+this.businessAccountId+'&searchText='+this.jobText)
        .then((response) => {
          console.log("getting jobs list by searchtect : ", response.data)
          this.jobsearchLoader = false;
          this.searchJobsList = response.data;
        }).catch((e) => {
          this.jobsearchLoader = false;
          console.log(e.response)
        })
      }
    },
    selectingJobFroRequest : function(job) {
      this.selectedJobForRequest = job;
      this.clearSelectedJobData()
    },
    clearSelectedJobData : function() {
      this.searchJobsList = [];
      this.jobText = ''
    },
    //submitting resume request
    submitResumeRequest(){
      var vm = this;
      this.sendRequestBtnClicked = true;
      let obj = {
        userProfileId : this.userObject.profileId,
        employeeId : this.recruiterProfileId,
        companyProfileId : this.selectedJobForRequest.companyProfileId,
        message : this.message,
        jobId : this.selectedJobForRequest.jobId,
        userEmailId : this.userEmail
      }
      httpjob.post('/postjob/insertInRequestResume', obj)
      .then((response) => {
        console.log("request sent successfully : ", response)
        this.clearSelectedJobData()
        this.sendRequestBtnClicked = false;
        this.selectedJobForRequest = null;
        this.message = ''
        vm.$toast.success("Request sent successfully")
        setTimeout(() => {
          this.close()
        },1000)
      }).catch((e) => {
        console.log("req error : ", e.response)
        if(e.response.data && e.response.data.errorMessage){
          vm.$toast.error(e.response.data.errorMessage)
        }else{
          vm.$toast.error("Something went wrong. Please try after some time.")
        }
        this.sendRequestBtnClicked = false;
      })
    }
  },
   mounted() {
    console.log("selected user :", this.userObject)
    this.businessAccountId = sessionUtils.getBusinessAccountId()
    this.userEmail = sessionUtils.getCompanyEmail()
    if(sessionUtils.getmodule() == 'Recruiter'){
      this.recruiterProfileId = sessionUtils.getCompanyProfileId()
    }
  },

}

</script>

<style scoped>
.modal-backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000 !important;
}
#introVideo{
  width: 100%;
  background: black;
}
.card {
    padding: -5px !important;
    margin: 0 auto;
}
label input[type="radio"]:checked ~ span {
    color: #007AFF;
}
.postmodalcontent{
  border: none !important;
}
.input-border:focus{
    outline: none !important;
}
#LocationDropdown{
  z-index: 3;
}
.dropdown-menu{
  display:block;    
  color: black;
  top: unset !important;
  box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
  border: none;
  margin-top: 0px;   
  border-radius: 10px  !important;
}
.list-group-item{
  padding: .25rem 0.25rem;
  border: none;
}
.list-group-item:hover{
  background: rgba(31,31,31,.2) !important;
}
.form-control:focus{
    outline: none !important;
    box-shadow: none !important;   
    border-radius: 10px;
    background-color: rgba(161, 166, 179,0.1);
    border: #DDDFE5;   
}
.btn:focus{
  box-shadow: none;
}
.tagLineReport{
	height: 10px;
	color: #1F1F1F;
	font-size: 10px;
	font-weight: bold;
	letter-spacing: 0;
	font-style: italic;
  opacity: 60%
}
.button-cancel11 {
  border: 1px solid #1f1f1f;
  border-radius: 4px;
  transition : ease-out 0.3s;
  font-size: 14px !important;
	position: relative;
	z-index : 1;
}
.modal-header{
  border: none;
}
.bodymodal11{
  /* height: 80vh; */
  overflow-y: auto;
}
.bodymodal11{
  background-color: white;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
/*hide scroll bar */
.bodymodal11::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.bodymodal11 {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.close{
  padding: 1px 7px 5px 7px !important;
  margin-top: -3px !important;
  margin-right: 5px !important;
  border: 1px solid white;
}
.close:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
@media screen and  (max-width : 600px){
  .card{
    margin-top: 4%;
  }
}
</style>